import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Api from '../../../Api';
import Dropdown from "../../../common/Dropdown";
import isEqual from "lodash.isequal";
import { PLEASE_SELECT } from "../../../../utils/constants";

function SeverityDropdown(props) {
    const [options, setOptions] = useState([]);
    const prevProps = useRef({});

    useEffect(() => {
        function isMissingInputs(props) {
            if (!props) return true;
            return !props.item.itemCode || !props.item.subItemCode || !props.damageCode;
        }

        async function getSeverities(signal, props) {
            return Api.getSeverities({
                ...props.item,
                damageCode: props.damageCode,
                groupCode: props.groupCode,
                category: props.categoryCode,
                signal
            });
        }

        if (!isEqual(prevProps.current, props)) {
            if (isMissingInputs(props)) {
                setOptions([]);
                prevProps.current = props;
            } else if (
                prevProps.current.damageCode !== props.damageCode ||
                prevProps.current.item?.itemCode !== props.item.itemCode ||
                prevProps.current.item?.subItemCode !== props.item.subItemCode
            ) {
                const abortController = new AbortController();
                const signal = abortController.signal;

                getSeverities(signal, props).then(response => {
                    if (response.items) {
                        const found = response.items.find(
                            item => item.severity.code === props.value
                        );

                        if (!found && props.value) {
                            props.onChange &&
                                props.onChange({
                                    target: {
                                        value: '',
                                        options: response.items,
                                        selectedIndex: 0
                                    }
                                });
                        }

                        setOptions(response.items);

                        if (response.items.length === 1 && !props.value) {
                            const selectedOption = response.items[0].severity;
                            const selectedOptions = [{}, { text: selectedOption.description }];
                            props.onChange &&
                                props.onChange({
                                    target: {
                                        options: selectedOptions,
                                        selectedIndex: 1,
                                        value: selectedOption.code
                                    }
                                });
                        }
                    } else {
                        setOptions([]);
                        props.setStatusMessage &&
                            props.setStatusMessage("There was a problem fetching Severity list");
                    }
                });
                prevProps.current = props;
            }
        }
    }, [props]);

    const handleChange = (event) => {
        props.onChange && props.onChange(event);
    };

    return (
        <Dropdown
            disabled={((props.value === '' || props.value === null) && options.length === 0) || props.disabled || props.addDisabled}
            onChange={handleChange}
            value={props.value}
            id={props.id || 'severity-dropdown-comp'}
        >
            {!props.value && <option value='' disabled hidden>{PLEASE_SELECT}</option>}
            {options.length === 0 && props.value && !props.addDisabled && (
                <option value={props.value}>{props.description}</option>
            )}
            {options.length > 0 &&
                options.map(option => (
                    <option key={option.severity.code} value={option.severity.code}>
                        {option.severity.description}
                    </option>
                ))}
        </Dropdown>
    );
}

SeverityDropdown.propTypes = {
    item: PropTypes.shape({
        itemCode: PropTypes.string,
        subItemCode: PropTypes.string
    }).isRequired,
    damageCode: PropTypes.string,
    groupCode: PropTypes.string,
    categoryCode: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    setStatusMessage: PropTypes.func,
    disabled: PropTypes.bool,
    addDisabled: PropTypes.bool,
    id: PropTypes.string
};

SeverityDropdown.defaultProps = {
    disabled: false,
    addDisabled: false
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SeverityDropdown);
